import { render } from "./InterfaceTabs.vue?vue&type=template&id=686b8b44&scoped=true"
import script from "./InterfaceTabs.vue?vue&type=script&lang=js"
export * from "./InterfaceTabs.vue?vue&type=script&lang=js"

import "./InterfaceTabs.vue?vue&type=style&index=0&id=686b8b44&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686b8b44"]])

export default __exports__